'use client'
import clsx from 'clsx'
import { useAtomValue } from 'jotai'
import { forwardRef, type HTMLAttributes } from 'react'
import { loadingOverlayAtom } from './providers/atoms-provider'
import { Spinner } from './spinner'
import { Text } from './text'

type FullScreenLoadingOverlayProps = HTMLAttributes<HTMLDivElement>

const FullScreenLoadingOverlay = forwardRef<HTMLDivElement, FullScreenLoadingOverlayProps>((props, ref) => {
    const { className, ...otherProps } = props
    const { message, visible } = useAtomValue(loadingOverlayAtom)

    return (
        <div
            className={clsx(
                'absolute inset-0 z-[100] flex h-full w-full flex-col items-center justify-center gap-8 bg-white transition-opacity dark:bg-neutral-900',
                visible ? 'opacity-100' : 'pointer-events-none opacity-0',
                className,
            )}
            aria-hidden
            {...otherProps}
            ref={ref}
        >
            <Text type="title3">{message}</Text>
            <Spinner size="xxl" variant="primary" />
        </div>
    )
})

FullScreenLoadingOverlay.displayName = 'FullScreenLoadingOverlay'

export default FullScreenLoadingOverlay
